import { Grid, Box, Typography } from "@mui/material";
import React, { useContext } from "react";
import { MainContext } from "../../../../main/context/MainContextProvider";

export type AvailabilityAnalyInfoCardProps = {
    value: React.ReactNode;
    icon: React.ReactNode;
    title: string;
    backgroundColor?: string;
    gridXS?: number;
    valueColor?: string;
};

export default function AvailabilityAnalyInfoCard({ value, icon, title, backgroundColor, gridXS, valueColor }: AvailabilityAnalyInfoCardProps) {
    const { theme } = useContext(MainContext);

    return (
        <Grid item xs={gridXS || 4}>
            <Box sx={{
                backgroundColor: backgroundColor || theme.cardBoxBackgroudColor,
                padding: "10px",
                paddingX: "14px",
                borderRadius: "6px",
                border: `1px solid #334155`
            }}>
                <Typography sx={{ fontSize: "12px", color: theme.secondaryTextColor, textAlign: "left", marginBottom: "4px" }}>
                    {icon} {title}
                </Typography>
                <Typography sx={{ fontSize: "16px", fontWeight: "600", textAlign: "left", color: valueColor }}>
                    {value}
                </Typography>
            </Box>
        </Grid>
    )
}